const configService = {
  apiUrl: process.env.API_ENERGY,
  enable_decryption: process.env.ENABLE_DECRYPTION_API_ENERGY,
  api_decrypt_key:process.env.API_ENERGY_DECRYPTION_KEY,
  api_key:process.env.API_ENERGY_KEY
}

export default configService



// WEBPACK FOOTER //
// ./src/services/ducter-energy.js